import './Footer.css';

function Footer() {
    return (
      <footer>
        <h5>By Michael Legere. Last updated August 2026.</h5>
      </footer>
    );
  }

export default Footer;